"use strict";

exports.__esModule = true;
exports.isDef = isDef;
function isDef(val) {
  return val !== undefined && val !== null;
}


//////////////////
// WEBPACK FOOTER
// ./libs/element-ui/lib/utils/shared.js
// module id = 161
// module chunks = 0